// Apply a LoadedReceipt to the shared virtual filesystem so the
// verifier (which reads through node:fs/promises) can find the files.

import { clearVirtualFs, registerFile } from "../shims/virtual-fs.js";
import type { LoadedReceipt } from "./types.js";

export function installReceiptInVirtualFs(loaded: LoadedReceipt): void {
  clearVirtualFs();
  for (const [relativePath, contents] of loaded.files) {
    const fullPath = joinUnderRoot(loaded.packageDirectory, relativePath);
    registerFile(fullPath, contents);
  }
}

function joinUnderRoot(root: string, relativePath: string): string {
  const normalizedRoot = root.replace(/\/+$/, "");
  const normalizedRelative = relativePath.replace(/^\/+/, "");
  return `${normalizedRoot}/${normalizedRelative}`;
}
